<template>

    <div class="module h-full flex flex-col px-8 relative">

        <loader :loading="loading" />

        <!-- <router-link :to="{ name:'home' }" class="flex items-center mb-4">
            <div class="header-btn mr-2 ml-0">
                <i class="mdi mdi-home"></i>
            </div>
            <div class="text-font-gray">Return to home</div>
        </router-link> -->

        <div class="flex flex-no-wrap h-6 mb-2" v-if="Object.keys(data).length">
            <div class="w-28 flex-none mr-1" />
                <Summary :row="data.summary.Win" />
            <div class="mx-1 w-4/9 flex-none flex p-0  border-b border-font-gray flex px-2">
                <OnGoing :row="data.summary.OnGoing" />
            </div>
            <div class=" mx-1 w-full  border-b border-font-gray flex px-2">
                <Lost :row="data.summary.Lost" />
            </div>
            <div class="w-28 flex-none ml-1 " />
        </div>

        <div v-if="data.summary_ongoing">
            <SummaryOngoing :row="data.summary_ongoing" />
        </div>

        <div class="h-full overflow-hidden relative" >
            <div class="scroll-gradient" />
            <div class="h-full overflow-y-auto pb-10">
                <div class="flex flex-no-wrap h-36 mb-2" v-for="(el, key) in data.circles" :key="key">
                    <div class="box w-28 flex-none text-center text-xl text-aux flex items-center justify-center mr-1">
                        {{ key }}
                    </div>
                    <div class="box w-full mx-1 flex p-0">
                        <div class="w-full p-2 flex overflow-x-hidden overflow-y-auto flex-wrap -mx-2">
                            <template v-for="(ball, k) in el.Win" v-if="k !== 'total'">
                                <BallWin :row="ball" :k="k" :data="data"/>
                            </template>
                        </div>
                        <BallWinTotal :row="el.Win" />
                    </div>
                    <div class="box w-4/9 mx-1 flex-none flex p-0" >
                        <template v-for="(perc) in ['25','50','75','100']">
                            <div class="w-full p-2 overflow-hidden">
                                <div class="flex overflow-x-hidden overflow-y-auto flex-wrap -mx-2 h-full"
                                    v-if="el.hasOwnProperty('OnGoing') && el.OnGoing.hasOwnProperty(perc)">
                                    <template v-for="(ball, k) in el.OnGoing[perc]" v-if="k !== 'total'">
                                        <BallOngoing :row="ball" :k="k" :data="data"/>
                                    </template>
                                </div>
                            </div>
                            <separator direction="vertical"/>
                        </template>
                        <BallOnGoingTotal :row="el" />
                    </div>
                    <div class="box w-full mx-1 p-0 flex">
                        <div class="w-full p-2 overflow-hidden">
                            <div class="flex overflow-x-hidden overflow-y-auto flex-wrap -mx-2 h-full"  v-if="el.hasOwnProperty('Lost')">
                                <template v-for="(ball,k) in el.Lost" v-if="k !== 'total'">
                                    <BallLost :row="ball" :k="k" :data="data" />
                                </template>
                            </div>
                        </div>
                        <BallLostTotal :row="el" />
                    </div>
                    <Totals :row="el" />
                </div>
            </div>
        </div>

        <div class="box">
            <div class="flex justify-around items-center">
                <div v-for="(sector, index) in data.sectors" class="text-base rounded-full py-2 px-4"
                    :style="'color:' + legendColors[sector] + ';background-color:' + legendColors[sector] + '22'">
                    {{ sector }}
                </div>
            </div>
        </div>

    </div>

</template>
<script>

    import { state } from '@/store';
    const Summary = () => import("@/components/Desktop/Pipeline/Summary/Summary");
    const OnGoing = () => import("@/components/Desktop/Pipeline/Summary/OnGoing");
    const Lost = () => import("@/components/Desktop/Pipeline/Summary/Lost");
    const SummaryOngoing = () => import("@/components/Desktop/Pipeline/SummaryOngoing");
    const BallWin = () => import("@/components/Desktop/Pipeline/Balls/BallWin");
    const BallWinTotal = () => import("@/components/Desktop/Pipeline/Balls/BallWinTotal");
    const BallOngoing = () => import("@/components/Desktop/Pipeline/Balls/BallOngoing");
    const BallOnGoingTotal = () => import("@/components/Desktop/Pipeline/Balls/BallOnGoingTotal");
    const BallLost = () => import("@/components/Desktop/Pipeline/Balls/BallLost");
    const BallLostTotal = () => import("@/components/Desktop/Pipeline/Balls/BallLostTotal");
    const Totals = () => import("@/components/Desktop/Pipeline/Totals")

    export default {
        components: {
            BallLostTotal,
            Summary,
            OnGoing,
            Lost,
            SummaryOngoing,
            BallWin,
            BallWinTotal,
            BallOngoing,
            BallOnGoingTotal,
            BallLost,
            Totals
        },
        data() {
            return {
                data: {
                    summary: {},
                    circles: {},
                    sectors: {}
                },
                loading: false,

            }
        },
        computed: {
            params() { return state.globalParams },
            legendColors() { return this.$legendColorsBySector(this.data.sectors) }
        },
        watch: {
            params(n, o) { this.getBalls() }
        },
        methods: {
            getBalls() {
                this.loading = true;
                this.axios.get('pipeline/service_line', { params: this.params }).then(response => {
                    this.loading = false
                    this.data = response.data.data
                })
            },
            publicComment(commentary){
            }
        },
        mounted() { this.getBalls() }
    }
</script>